// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32grq","right":"styles_right__2n-2S"};